/*
 * @Description: 信息流创意
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-09-25 15:59:56
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-16 16:03:39
 */
<template>
    <div class="info">
        <div v-if="infoList.length" class="panel-row">
            <div class="info-title">已生成广告</div>
            <div v-if="status.action != 'edit' && status.type != 'creative'" class="info-list">
                <div
                    v-for="(group, index) in infoBuildList"
                    v-if="group.list.length"
                    :key="index"
                    class="info-group"
                    :data-title="group.title"
                >
                    <cInfo
                        v-for="(item, i) in group.list"
                        :error="infoListError[0]"
                        @edit="editInfo(item)"
                        :hover="true"
                        :key="i"
                        :type="group.type"
                        :icon="item.iconUrl"
                        :img="item.imgUrl"
                        :title="item.title"
                        :desc="item.description"
                        :name="item.name"
                        :buttonText="item.buttonText"
                        @delete="deleteInfo(item)"
                    />
                </div>
            </div>
        </div>
        <div id="info" v-show="show.template" class="panel-row">
            <div class="info-title">{{ status == 'add' ? '新建' : '编辑' }}多尺寸通投</div>
            <!-- 模板 -->
            <div class="template-box">
                <div class="template">
                    <!-- 尺寸选择 -->
                    <div v-if="status == 'add'" class="size-box">
                        <div class="size-box-title">尺寸选择</div>
                        <div class="size-list">
                            <div
                                v-for="item in sizeList"
                                :key="item.title"
                                class="size-item"
                                @click="item.selected = !item.selected"
                            >
                                <img :src="`/static/img/${item.title}.jpg`" :alt="item.title" />
                                <span>{{ item.title }}</span>
                                <span>{{ item.size }}</span>
                                <Checkbox @click.stop v-model="item.selected"></Checkbox>
                            </div>
                        </div>
                    </div>
                    <!-- 广告名称 -->
                    <div v-if="status == 'edit'" class="text-box">
                        <div class="panel-row">
                            <p class="panel-row-label">
                                <span>广告名称</span>
                                <span v-if="infoError.textList[0].name" class="panel-row-error">
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon
                                    >请输入35个字符以内的广告名称
                                </span>
                            </p>
                            <Input
                                v-model="infoParams.textList[0].name"
                                :placeholder="`必填，请输入35个字符以内的内容`"
                                :maxlength="35"
                            />
                        </div>
                    </div>
                    <!-- 文案组 -->
                    <div class="text-box" v-for="(item, index) in infoParams.textList" :key="index">
                        <div class="text-title">
                            <span>文案{{ index + 1 }}</span>
                            <span
                                v-show="index > 0 || infoParams.textList.length > 1"
                                @click="infoParams.textList.splice(index, 1)"
                            >
                                <Icon title="删除" class="icon-delete" type="android-delete"></Icon>
                            </span>
                        </div>
                        <!-- 标题 -->
                        <div class="panel-row">
                            <p class="panel-row-label">
                                <span>标题</span>
                                <span v-if="infoError.textList[index].title && item.blurTitle" class="panel-row-error">
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon
                                    >请输入50个字符以内的创意标题
                                </span>
                            </p>
                            <Input
                                v-model="item.title"
                                @on-blur="$set(item, 'blurTitle', true)"
                                :placeholder="`必填，建议输入25个字符以内的内容`"
                                :maxlength="200"
                            />
                        </div>
                        <!-- 描述 -->
                        <div class="panel-row">
                            <p class="panel-row-label">
                                <span>描述</span>
                                <span
                                    v-if="infoError.textList[index].description && item.blurDescription"
                                    class="panel-row-error"
                                >
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon
                                    >请输入200个字符以内的描述
                                </span>
                            </p>
                            <Input
                                v-model="item.description"
                                @on-blur="$set(item, 'blurDescription', true)"
                                type="textarea"
                                :rows="3"
                                :placeholder="`必填，建议输入90个字符以内的内容`"
                                :maxlength="200"
                            />
                        </div>
                        <!-- 按钮文案 -->
                        <div class="panel-row">
                            <p class="panel-row-label">
                                <span>按钮文案</span>
                                <span
                                    v-if="infoError.textList[index].buttonText && item.blurButtonText"
                                    class="panel-row-error"
                                >
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon
                                    >请输入11个字符以内的创意按钮文案
                                </span>
                            </p>
                            <Dropdown
                                @on-click="(text) => (item.buttonText = text)"
                                trigger="click"
                                style="width: 5.8rem"
                            >
                                <Input
                                    v-model="item.buttonText"
                                    @on-blur="$set(item, 'blurButtonText', true)"
                                    style="width: 100%"
                                    :placeholder="`必填，按钮文案建议11个字符`"
                                    :maxlength="11"
                                />
                                <DropdownMenu slot="list">
                                    <DropdownItem v-for="text in buttonTextList" :key="text" :name="text">{{
                                        text
                                    }}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                    <!-- 添加文案 -->
                    <div v-if="status == 'add'" class="panel-row">
                        <div @click="addText" class="add-text">
                            <p>+ 添加文案</p>
                        </div>
                    </div>
                    <!-- 图片上传 -->
                    <div
                        v-if="!(status == 'edit' && infoParams.imgList[0] && infoParams.imgList[0].sizeType == 5)"
                        class="template-group"
                    >
                        <!-- 1200x627 -->
                        <div class="panel-row no-margin">
                            <p class="panel-row-label">
                                <span>图片上传</span>
                                <span v-if="infoError.imgUrl && blur.imgUrl" class="panel-row-error">
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon>请上传至少一张图片
                                </span>
                            </p>
                            <div class="banner-img-list">
                                <!-- 上传框 -->
                                <div class="banner-img-item">
                                    <!-- 影子元素 -->
                                    <input
                                        ref="imgUrl"
                                        type="file"
                                        hidden
                                        :multiple="status == 'add'"
                                        accept="image/jpeg, image/jpg, image/png"
                                        @change="onFileChange($event, 'imgUrl')"
                                    />
                                    <!-- 上传中动画 -->
                                    <cSpin
                                        v-if="loading.imgUrl"
                                        :size="0.1"
                                        :radius="0.05"
                                        color="#23c52f"
                                        background="#fafafa"
                                    />
                                    <div @click="$refs.imgUrl.click()" class="item-upload">
                                        <Icon class="item-upload-icon" type="plus-round"></Icon>
                                        <span class="item-upload-text">上传</span>
                                    </div>
                                </div>
                                <!-- 缩略图框 -->
                                <div v-for="(item, index) in infoParams.imgList" :key="index" class="banner-img-item">
                                    <div
                                        @mouseover="item.showFunction = true"
                                        @mouseout="item.showFunction = false"
                                        class="item-img-box"
                                    >
                                        <img class="item-img" :src="item.imgUrl" />
                                        <transition name="fade">
                                            <div v-show="item.showFunction" class="img-function">
                                                <span
                                                    @click="previewImg(item.imgUrl, allSizeList[item.sizeType])"
                                                    class="function-icon"
                                                >
                                                    <Icon type="eye"></Icon>
                                                </span>
                                                <span
                                                    @click="infoParams.imgList.splice(index, 1)"
                                                    class="function-icon"
                                                >
                                                    <Icon type="android-delete"></Icon>
                                                </span>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                            <p v-if="currentSizeType == 8 && status == 'edit'" class="panel-row-label no-margin">
                                尺寸：320x200;格式：jpg，png；大小：200KB
                            </p>
                            <p v-else-if="currentSizeType == 10 && status == 'edit'" class="panel-row-label no-margin">
                                尺寸：640x360;格式：jpg，png；大小：200KB
                            </p>
                            <p v-else class="panel-row-label no-margin">
                                尺寸：1200x627，1200x628;格式：jpg，png；大小：200KB
                            </p>
                        </div>
                        <!-- 320x200 -->
                        <div v-if="status == 'add'" class="panel-row native-upload">
                            <p class="panel-row-label">上传自定义320*200图片，或点击裁剪按钮裁剪已上传的图片</p>
                            <p class="panel-row-label" v-if="infoError.nativeImgUrl && blur.imgUrl">
                                <span class="panel-row-error" style="margin: 0">
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon>请上传至少一张图片
                                </span>
                            </p>
                            <div class="banner-img-list">
                                <!-- 上传框 -->
                                <div class="banner-img-item">
                                    <!-- 影子元素 -->
                                    <input
                                        ref="nativeImgUrl"
                                        type="file"
                                        hidden
                                        :multiple="status == 'add'"
                                        accept="image/jpeg, image/jpg, image/png"
                                        @change="onFileChange($event, 'nativeImgUrl')"
                                    />
                                    <!-- 上传中动画 -->
                                    <cSpin
                                        v-if="loading.nativeImgUrl"
                                        :size="0.1"
                                        :radius="0.05"
                                        color="#23c52f"
                                        background="#fafafa"
                                    />
                                    <div @click="$refs.nativeImgUrl.click()" class="item-upload">
                                        <Icon class="item-upload-icon" type="plus-round"></Icon>
                                        <span class="item-upload-text">上传</span>
                                    </div>
                                </div>
                                <!-- 缩略图框 -->
                                <div
                                    v-for="(item, index) in infoParams.nativeImgList"
                                    :key="index"
                                    class="banner-img-item"
                                >
                                    <div
                                        @mouseover="item.showFunction = true"
                                        @mouseout="item.showFunction = false"
                                        class="item-img-box"
                                    >
                                        <img class="item-img" :src="item.imgUrl" />
                                        <transition name="fade">
                                            <div v-show="item.showFunction" class="img-function">
                                                <span @click="previewImg(item.imgUrl, '320x200')" class="function-icon">
                                                    <Icon type="eye"></Icon>
                                                </span>
                                                <span
                                                    @click="infoParams.nativeImgList.splice(index, 1)"
                                                    class="function-icon"
                                                >
                                                    <Icon type="android-delete"></Icon>
                                                </span>
                                                <span @click="showCropper(item)" class="function-icon">
                                                    <Icon type="crop"></Icon>
                                                </span>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                            <p class="panel-row-label no-margin">尺寸：320x200;格式：jpg，png；大小：200KB</p>
                        </div>
                        <!-- 640x360 -->
                        <div v-if="status == 'add'" class="panel-row native-upload">
                            <p class="panel-row-label">上传自定义640*360图片，或点击裁剪按钮裁剪已上传的图片</p>
                            <p class="panel-row-label" v-if="infoError.native_3ImgUrl && blur.imgUrl">
                                <span class="panel-row-error" style="margin: 0">
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon>请上传至少一张图片
                                </span>
                            </p>
                            <div class="banner-img-list">
                                <!-- 上传框 -->
                                <div class="banner-img-item">
                                    <!-- 影子元素 -->
                                    <input
                                        ref="native_3ImgUrl"
                                        type="file"
                                        hidden
                                        :multiple="status == 'add'"
                                        accept="image/jpeg, image/jpg, image/png"
                                        @change="onFileChange($event, 'native_3ImgUrl')"
                                    />
                                    <!-- 上传中动画 -->
                                    <cSpin
                                        v-if="loading.native_3ImgUrl"
                                        :size="0.1"
                                        :radius="0.05"
                                        color="#23c52f"
                                        background="#fafafa"
                                    />
                                    <div @click="$refs.native_3ImgUrl.click()" class="item-upload">
                                        <Icon class="item-upload-icon" type="plus-round"></Icon>
                                        <span class="item-upload-text">上传</span>
                                    </div>
                                </div>
                                <!-- 缩略图框 -->
                                <div
                                    v-for="(item, index) in infoParams.native_3ImgList"
                                    :key="index"
                                    class="banner-img-item"
                                >
                                    <div
                                        @mouseover="item.showFunction = true"
                                        @mouseout="item.showFunction = false"
                                        class="item-img-box"
                                    >
                                        <img class="item-img" :src="item.imgUrl" />
                                        <transition name="fade">
                                            <div v-show="item.showFunction" class="img-function">
                                                <span @click="previewImg(item.imgUrl, '640x360')" class="function-icon">
                                                    <Icon type="eye"></Icon>
                                                </span>
                                                <span
                                                    @click="infoParams.native_3ImgList.splice(index, 1)"
                                                    class="function-icon"
                                                >
                                                    <Icon type="android-delete"></Icon>
                                                </span>
                                                <span @click="showCropper(item)" class="function-icon">
                                                    <Icon type="crop"></Icon>
                                                </span>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                            <p class="panel-row-label no-margin">尺寸：640x360;格式：jpg，png；大小：200KB</p>
                        </div>
                    </div>
                    <!-- LOGO上传 -->
                    <div class="template-group">
                        <div class="panel-row no-margin">
                            <p class="panel-row-label">
                                <span>LOGO上传</span>
                                <span v-if="infoError.iconUrl && blur.iconUrl" class="panel-row-error">
                                    <Icon class="panel-row-error-icon" type="close-circled"></Icon>请上传LOGO
                                </span>
                            </p>
                            <div class="banner-img-list">
                                <div class="banner-img-item">
                                    <!-- 影子元素 -->
                                    <input
                                        ref="iconUrl"
                                        type="file"
                                        hidden
                                        accept="image/jpeg, image/jpg, image/png"
                                        @change="onFileChange($event, 'iconUrl')"
                                    />
                                    <!-- 上传中动画 -->
                                    <cSpin
                                        v-if="loading.iconUrl"
                                        :size="0.1"
                                        :radius="0.05"
                                        color="#23c52f"
                                        background="#fafafa"
                                    />
                                    <!-- 上传框 -->
                                    <div @click="$refs.iconUrl.click()" class="item-upload">
                                        <Icon class="item-upload-icon" type="plus-round"></Icon>
                                        <span class="item-upload-text">上传</span>
                                    </div>
                                </div>
                                <div v-if="infoParams.iconUrl" class="banner-img-item">
                                    <!-- 缩略图框 -->
                                    <div
                                        @mouseover="iconFunction = true"
                                        @mouseout="iconFunction = false"
                                        class="item-img-box"
                                    >
                                        <img class="item-img" :src="infoParams.iconUrl" />
                                        <transition name="fade">
                                            <div v-show="iconFunction" class="img-function">
                                                <span
                                                    @click="previewImg(infoParams.iconUrl, '84x84')"
                                                    class="function-icon"
                                                >
                                                    <Icon type="eye"></Icon>
                                                </span>
                                                <span @click="infoParams.iconUrl = ''" class="function-icon">
                                                    <Icon type="android-delete"></Icon>
                                                </span>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                            <p class="panel-row-label no-margin">尺寸：84x84;格式：jpg，png；大小：100KB</p>
                        </div>
                    </div>
                    <!-- 生成广告 -->
                    <div
                        v-if="promotionStatus.action != 'edit' || promotionStatus.type != 'creative'"
                        class="template-group"
                        style="padding: 0.2rem"
                    >
                        <Button v-if="status == 'add'" @click="buildInfo" type="default" size="large">生成广告</Button>
                        <Button v-if="status == 'edit'" @click="saveInfo" type="info" size="large">保存</Button>
                        <Button @click="show.template = false" type="text" size="large">取消</Button>
                    </div>
                </div>
                <!-- 实时预览 -->
                <div class="preview">
                    <RadioGroup v-model="previewType" type="button" class="preview-nav" size="small">
                        <Radio
                            v-for="(item, index) in sizeList"
                            v-if="item.selected"
                            :key="item.title"
                            :label="index"
                            >{{ item.title }}</Radio
                        >
                    </RadioGroup>
                    <div class="preview-detail">
                        <template v-if="infoPreviewSortList.length">
                            <cInfo
                                style="margin: 0 auto"
                                :type="sizeList[previewType].type"
                                :icon="infoPreviewSortList[currentPreview].iconUrl"
                                :img="infoPreviewSortList[currentPreview].imgUrl"
                                :title="infoPreviewSortList[currentPreview].title"
                                :desc="infoPreviewSortList[currentPreview].description"
                                :buttonText="infoPreviewSortList[currentPreview].buttonText"
                            />
                            <p v-if="sizeList[previewType].type == 'Native'" class="preview-tip">
                                注：信息流广告会根据不同的媒体 <br />生成对应风格的原生广告
                            </p>
                        </template>
                        <p v-else class="preview-tip">填写正确完整的信息后将出现预览</p>
                        <i
                            v-if="infoPreviewSortList.length > 1 && currentPreview"
                            @click="changePreview('left')"
                            class="left"
                        >
                            <Icon type="chevron-left"></Icon>
                        </i>
                        <i
                            v-if="infoPreviewSortList.length > 1 && currentPreview < infoPreviewSortList.length - 1"
                            @click="changePreview('right')"
                            class="right"
                        >
                            <Icon type="chevron-right"></Icon>
                        </i>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="promotionStatus.action != 'edit' || promotionStatus.type != 'creative'" class="template-btn-group">
            <Button @click="dataInit('add')" type="info" size="large">新建多尺寸通投</Button>
            <Button @click="show.library = true" type="info" size="large" style="margin-left: 0.3rem"
                >创意库选择</Button
            >
        </div>
        <cropper v-model="show.cropper" :item="currentImg" />
        <library v-model="show.library" :creativeType="2" @submit="onLibrarySubmit" />
    </div>
</template>
<script>
import Compress from '@/server/compress.js';
import cInfo from '@/components/commons/cInfo.vue';
import cSpin from '@/components/commons/cSpin.vue';
import library from '@/components/NewPromotion/library.vue';
import cropper from '@/components/NewPromotion/cropper.vue';
export default {
    name: 'Info',
    components: { cInfo, cSpin, library, cropper },
    data() {
        return {
            show: {
                template: false,
                library: false,
                cropper: false,
            },
            loading: {
                iconUrl: false,
                imgUrl: false,
                nativeImgUrl: false,
                native_3ImgUrl: false,
            },
            iconFunction: false,
            blur: {
                iconUrl: false,
                imgUrl: false,
                nativeImgUrl: false,
                native_3ImgUrl: false,
            },
            status: 'add', //当前状态,add or edit
            currentInfo: {},
            currentImg: {},
            currentPreview: 0,
            currentSizeType: 0,
            previewType: 0,
            //尺寸选择
            sizeList: [
                { title: 'Banner', size: '320x50', sizeType: 5, type: 'Banner', selected: false },
                { title: 'Mrec', size: '300x250', sizeType: 1, type: 'Mrec', selected: false },
                { title: 'Interstitial', size: '320x480', sizeType: 6, type: 'Interstitial', selected: false },
                { title: 'Native_1', size: '1200x627', sizeType: 7, type: 'Native', selected: false },
                { title: 'Native_2', size: '320x200', sizeType: 8, type: 'Native', selected: false },
                { title: 'Native_3', size: '640x360', sizeType: 10, type: 'Native', selected: false },
            ],
        };
    },
    computed: {
        promotionStatus() {
            return this.$store.state.newPromotion.status;
        },
        infoList() {
            return this.$store.state.newPromotion.infoList;
        },
        infoBuildList() {
            const list = this.infoList;
            return [
                { title: 'Banner', type: 'Banner', list: list.filter((item) => item.sizeType == 5) },
                { title: 'Medium Rectangle', type: 'Mrec', list: list.filter((item) => item.sizeType == 1) },
                { title: 'Interstitial', type: 'Interstitial', list: list.filter((item) => item.sizeType == 6) },
                { title: 'Native_1（1200x627）', type: 'Native', list: list.filter((item) => item.sizeType == 7) },
                { title: 'Native_2（320x200）', type: 'Native', list: list.filter((item) => item.sizeType == 8) },
                { title: 'Native_3（640x360）', type: 'Native', list: list.filter((item) => item.sizeType == 10) },
            ];
        },
        infoListError() {
            return this.infoList.map(
                (item) =>
                    !item.title ||
                    item.title.length > 50 ||
                    !item.description ||
                    item.description.length > 200 ||
                    !item.buttonText ||
                    item.buttonText.length > 11
            );
        },
        infoParams() {
            return this.$store.state.newPromotion.infoParams;
        },
        infoTemplate() {
            return this.$store.state.newPromotion.infoTemplate;
        },
        buttonTextList() {
            return this.$store.state.newPromotion.buttonTextList;
        },
        allSizeList() {
            return this.$store.state.newPromotion.sizeList;
        },
        //错误验证
        infoError() {
            const { sizeList, infoParams } = this;
            return {
                size: sizeList.every((item) => !item.selected),
                textList: infoParams.textList.map((item) => ({
                    name: !item.name || item.name.length > 35,
                    title: !item.title || item.title.length > 200,
                    description:
                        (!item.description || item.description.length > 200) &&
                        sizeList.some((item) => item.sizeType != 5 && item.selected),
                    buttonText: !item.buttonText || item.buttonText.length > 11,
                })),
                imgUrl:
                    sizeList.some(
                        (item) => item.sizeType != 8 && item.sizeType != 5 && item.sizeType != 10 && item.selected
                    ) && !infoParams.imgList.length,
                nativeImgUrl:
                    this.status == 'add' &&
                    sizeList.some((item) => item.sizeType == 8 && item.selected) &&
                    !infoParams.nativeImgList.length,
                native_3ImgUrl:
                    this.status == 'add' &&
                    sizeList.some((item) => item.sizeType == 10 && item.selected) &&
                    !infoParams.native_3ImgList.length,
                iconUrl: !infoParams.iconUrl,
            };
        },
        //预览列表
        infoPreviewList() {
            const error = this.infoError,
                params = this.infoParams,
                sizeList = this.sizeList,
                status = this.status,
                arr = [];
            //通过验证
            const reg = !(
                error.textList.some((item) => item.title || item.description || item.buttonText) ||
                error.nativeImgUrl ||
                error.native_3ImgUrl ||
                error.iconUrl ||
                error.size ||
                error.imgUrl
            );
            if (reg) {
                params.textList.forEach((text, index) => {
                    if (sizeList.some((item) => item.selected)) {
                        // 其他尺寸
                        sizeList.forEach((size) => {
                            //320x50尺寸不参与图片变量
                            if (size.selected && size.sizeType != 5) {
                                params.imgList.forEach((img, imgIndex) => {
                                    //添加非320x200尺寸或编辑
                                    if ((status == 'add' && size.sizeType != 8) || status == 'edit') {
                                        arr.push({
                                            creativeType:
                                                size.sizeType == '7' || size.sizeType == '8' || size.sizeType == '10'
                                                    ? 2
                                                    : 5,
                                            status: 1,
                                            iconUrl: params.iconUrl,
                                            title: text.title,
                                            description: text.description,
                                            buttonText: text.buttonText,
                                            name: `${img.name.substring(0, 30)}${
                                                params.textList.length > 1 ? '_' + (index + 1) : ''
                                            }`,
                                            imgUrl: img.imgUrl,
                                            sizeType: size.sizeType,
                                        });
                                    }
                                });
                            }
                            //320x50尺寸
                            else if (size.selected && size.sizeType == 5) {
                                arr.push({
                                    creativeType: 5,
                                    status: 1,
                                    iconUrl: params.iconUrl,
                                    title: text.title,
                                    description: text.title,
                                    buttonText: text.buttonText,
                                    name: `${text.title.substring(0, 30)}${
                                        params.textList.length > 1 ? '_' + (index + 1) : ''
                                    }`,
                                    imgUrl: params.iconUrl,
                                    sizeType: 5,
                                });
                            }
                        });
                    }
                    if (status == 'add' && sizeList.some((item) => item.selected && item.sizeType == 8)) {
                        // 320x200尺寸
                        params.nativeImgList.forEach((img) => {
                            arr.push({
                                creativeType: 2,
                                status: 1,
                                iconUrl: params.iconUrl,
                                title: text.title,
                                description: text.description,
                                buttonText: text.buttonText,
                                name: `${img.name.substring(0, 30)}${
                                    params.textList.length > 1 ? '_' + (index + 1) : ''
                                }`,
                                imgUrl: img.imgUrl,
                                sizeType: 8,
                            });
                        });
                    }
                    if (status == 'add' && sizeList.some((item) => item.selected && item.sizeType == 10)) {
                        // 640x360尺寸
                        params.native_3ImgList.forEach((img) => {
                            arr.push({
                                creativeType: 2,
                                status: 1,
                                iconUrl: params.iconUrl,
                                title: text.title,
                                description: text.description,
                                buttonText: text.buttonText,
                                name: `${img.name.substring(0, 30)}${
                                    params.textList.length > 1 ? '_' + (index + 1) : ''
                                }`,
                                imgUrl: img.imgUrl,
                                sizeType: 10,
                            });
                        });
                    }
                });
            }
            return arr;
        },
        infoPreviewSortList() {
            return this.infoPreviewList.filter((item) => item.sizeType == this.sizeList[this.previewType].sizeType);
        },
    },
    watch: {
        infoPreviewList: function (newVal) {
            //初始化currentPreview
            if (newVal.length < this.currentPreview + 1) this.currentPreview = 0;
            //初始化previewType
            if (!this.sizeList[this.previewType].selected) {
                let flag = true;
                this.sizeList.forEach((item, index) => {
                    if (item.selected && flag) {
                        this.previewType = index;
                        flag = false;
                    }
                });
            }
        },
        infoParams: function (newVal) {
            if (this.status == 'edit' && newVal.imgList[0] && newVal.imgList[0].sizeType) {
                this.currentSizeType = newVal.imgList[0].sizeType;
                this.sizeList.forEach((item, index) => {
                    if (item.sizeType == this.currentSizeType) {
                        this.previewType = index;
                        item.selected = true;
                    } else {
                        item.selected = false;
                    }
                });
            }
        },
    },
    created() {
        if (this.promotionStatus.type == 'creative') {
            if (this.promotionStatus.action == 'edit') {
                this.dataInit('edit');
                this.show.template = true;
                return;
            }
        }

        this.dataInit('add');
        this.show.template = false;
    },
    methods: {
        /**
         * @desc 数据初始化
         * @param type add or edit
         */
        dataInit(type) {
            //切换状态时提醒
            if (type != this.status && this.show.template == true) {
                let message = '';
                if (type == 'edit') message = '编辑广告将覆盖新增填写框，覆盖不会保存已输入内容，是否继续操作？';
                if (type == 'add') message = '新增多尺寸通投将覆盖编辑填写框，覆盖不会保存已输入内容，是否继续操作？';
                this.$Modal.confirm({
                    content: message,
                    okText: '继续',
                    onOk: () => {
                        this.status = type;
                        this.dataInit(type);
                    },
                });
                return;
            }
            // this.sizeList.forEach((item) => (item.selected = true));
            this.$store.commit('infoParams', JSON.parse(JSON.stringify(this.infoTemplate)));
            this.blur = { iconUrl: false, imgUrl: false, nativeImgUrl: false, native_3ImgUrl: false };
            this.status = type;
            this.show.template = true;

            if (type == 'edit') {
                this.blur = { iconUrl: true, imgUrl: true };
                const currentInfo = this.currentInfo;
                this.currentSizeType = currentInfo.sizeType;
                this.$store.commit('infoParams', {
                    ...this.infoParams,
                    textList: [
                        {
                            name: currentInfo.name,
                            title: currentInfo.title,
                            description: currentInfo.description,
                            buttonText: currentInfo.buttonText,
                            blurTitle: true,
                            blurDescription: true,
                            blurButtonText: true,
                        },
                    ],
                    imgList: [
                        {
                            name: currentInfo.name,
                            imgUrl: currentInfo.imgUrl,
                            sizeType: currentInfo.sizeType,
                            showFunction: false,
                        },
                    ],
                    iconUrl: currentInfo.iconUrl,
                });
            }
        },
        /**
         * @desc 新增文案
         */
        addText() {
            this.infoParams.textList.push({
                title: '',
                description: '',
                buttonText: '',
                blurTitle: false,
                blurDescription: false,
                blurButtonText: false,
            });
        },
        /**
         * @desc 显示图片裁剪框
         * @param {Item} item 320x200 img对象
         */
        showCropper(item) {
            this.show.cropper = true;
            this.currentImg = item;
        },
        /**
         * @desc 多尺寸通投创意上传图片
         * @param {Event} e: 原生input事件
         * @param {String} type: 图片类型 imgUrl or iconUrl
         */
        onFileChange(e, type) {
            const files = Array.from(e.target.files);
            //没有选择图片则返回
            if (!files.length) return;

            // 尺寸限制200k
            if (files.some((file) => file.size > 1024 * 200)) {
                this.$Message.error({ content: '请上传正确大小的图片', duration: 2 });
                return;
            }
            // 尺寸限制
            let sizeList = {
                imgUrl: { 7: '1200x627', 9: '1200x628' },
                iconUrl: { 1: '84x84' },
                nativeImgUrl: { 8: '320x200' },
                native_3ImgUrl: { 10: '640x360' },
            }[type];
            if ([8].includes(this.currentSizeType) && this.status == 'edit' && type == 'imgUrl')
                sizeList = { 8: '320x200' };
            if ([10].includes(this.currentSizeType) && this.status == 'edit' && type == 'imgUrl')
                sizeList = { 10: '640x360' };
            this.verifyImgSize(files, sizeList, async (sizeList) => {
                this.loading[type] = true;

                const formData = new FormData();
                files.forEach((file) => formData.append('img', file));
                const res = await this.$axios.post(this.$port.manager.uploadImg, formData, { cancelLoading: true });

                //数据处理
                this.loading[type] = false;
                if (type == 'imgUrl') {
                    const arr = [];
                    const arr2 = [];
                    res.data.urls.forEach((url, index) => {
                        let item = {
                            imgUrl: url,
                            name: files[index].name.split('.')[0],
                            sizeType: this.status == 'edit' ? this.currentSizeType : 8,
                            showFunction: false,
                        };
                        // this.addBase(item, files[index]);
                        arr.push(item);
                        arr2.push({ ...item, sizeType: 7 });
                    });
                    if (this.status == 'add') {
                        this.infoParams.nativeImgList.push(...arr);
                        this.infoParams.imgList.push(...arr2);
                    }
                    if (this.status == 'edit') this.infoParams.imgList = arr;
                    this.blur.nativeImgUrl = true;
                }
                if (type == 'nativeImgUrl') {
                    const arr = [];
                    res.data.urls.forEach((url, index) => {
                        let item = {
                            imgUrl: url,
                            name: files[index].name.split('.')[0],
                            sizeType: 8,
                            showFunction: false,
                        };
                        // this.addBase(item, files[index]);
                        arr.push(item);
                    });
                    this.infoParams.nativeImgList.push(...arr);
                }
                if (type == 'native_3ImgUrl') {
                    const arr = [];
                    res.data.urls.forEach((url, index) => {
                        let item = {
                            imgUrl: url,
                            name: files[index].name.split('.')[0],
                            sizeType: 10,
                            showFunction: false,
                        };
                        // this.addBase(item, files[index]);
                        arr.push(item);
                    });
                    this.infoParams.native_3ImgList.push(...arr);
                }
                if (type == 'iconUrl') {
                    this.infoParams.iconUrl = res.data.urls[0];
                    this.iconFunction = false;
                }
                //清空input
                e.target.value = '';
                this.blur[type] = true;
            });
        },
        /**
         * @desc 添加base64数据
         * @param {Object} item 添加的对象
         * @param {File}  file 文件
         */
        addBase(item, file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                item.base = reader.result;
                const formData = new FormData();
                const img = new Image();
                img.src = item.base;
                img.onload = async () => {
                    const formData = new FormData();
                    formData.append('img', this.dataURLtoFile(Compress(img), `${item.name}.jpg`));
                    const res = await this.$axios.post(this.$port.manager.uploadImg, formData, {
                        cancelLoading: false,
                    });
                    item.imgUrl = res.data.urls[0];
                };
            };
        },
        /**
         * @desc 验证图片尺寸
         * @param {Array} files - 图片文件列表
         * @param {Array} sizeList - 可以上传的图片尺寸列表
         * @param {Function} callback - 验证成功回调函数
         */
        verifyImgSize(files, sizeList, callback) {
            let url = window.URL || window.webkitURL;
            let count = 0;
            const arr = [];
            files.forEach((file, index) => {
                let img = new Image();
                img.src = url.createObjectURL(file);
                img.onload = () => {
                    //检查是否符合尺寸
                    const bool = Object.entries(sizeList).some((item) => {
                        const bool = item[1] == `${img.width}x${img.height}`;
                        console.log(item, img.width, img.height);
                        if (bool) arr[index] = item[0];
                        return bool;
                    });
                    // 不符合
                    if (!bool) arr[index] = false;
                    count++;
                    if (count == files.length) {
                        const sizeList = arr.every((item) => item) ? arr : false;
                        if (sizeList) callback(sizeList);
                        else this.$Message.error({ content: '请上传正确尺寸的图片', duration: 2 });
                    }
                };
            });
        },
        /**
         * @desc 弹窗预览图片
         * @param {String} url 预览的图片地址
         * @param {String} size 宽x高
         */
        previewImg(url, size) {
            const maxWidth = 800;
            const minWidth = 418;
            const width = ~~size.split('x')[0];
            let modalWidth = width + 40 > minWidth ? width + 40 : minWidth;
            modalWidth = modalWidth > maxWidth + 40 ? maxWidth + 40 : modalWidth;
            this.$Modal.info({
                render: (h) =>
                    h('img', {
                        attrs: { src: url },
                        style: { width: `${width > maxWidth ? maxWidth : width}px`, margin: '0 auto' },
                    }),
                width: modalWidth,
                okText: '关闭',
            });
        },
        /**
         * @desc 切换预览
         * @param {String} type left or right
         */
        changePreview(type) {
            if (type == 'left') this.currentPreview -= this.currentPreview ? 1 : 0;
            if (type == 'right') this.currentPreview += this.currentPreview != this.infoPreviewList.length ? 1 : 0;
        },
        /**
         * @desc 生成广告
         */
        buildInfo() {
            //先验证再生成
            if (this.regInfo()) {
                this.$store.commit('infoList', [
                    ...this.infoList,
                    ...this.infoPreviewList.map((v) => {
                        if (v.creativeType === 2) {
                            v.name = v.title;
                        }
                        return v;
                    }),
                ]);
                this.show.template = false;
            }
        },
        /**
         * @desc 编辑某个info
         * @param {Object} item 编辑的info
         */
        editInfo(item) {
            this.currentInfo = item;
            this.dataInit('edit');
            this.$nextTick(() => {
                location.hash = '';
                location.hash = 'info';
            });
        },
        /**
         * @desc 保存正在编辑的info
         */
        saveInfo() {
            if (this.regInfo()) {
                const infoParams = this.infoParams;
                this.currentInfo = Object.assign(this.currentInfo, {
                    title: infoParams.textList[0].title,
                    description: infoParams.textList[0].description,
                    buttonText: infoParams.textList[0].buttonText,
                    name: infoParams.textList[0].name,
                    imgUrl: infoParams.imgList[0].imgUrl,
                    sizeType: infoParams.imgList[0].sizeType,
                    iconUrl: infoParams.iconUrl,
                });
                if (this.infoList.every((item) => item != this.currentInfo))
                    this.$store.commit('infoList', [...this.infoList, this.currentInfo]);
                this.show.template = false;
                this.$Message.success({ content: '编辑成功' });
            }
        },
        /**
         * @desc 验证填写的多尺寸通投
         * @return {Boolean}
         */
        regInfo() {
            const error = this.infoError;
            const message = [];
            if (error.size) message.push('请选择至少一个尺寸');
            if (error.textList.some((item) => item.title || item.description || item.buttonText))
                message.push('请填写正确长度的文案');
            if (this.status == 'edit' && error.textList.some((item) => item.name)) message.push('请填写正确广告名称');
            if (error.imgUrl) message.push('请上传1200x627或1200x628图片');
            if (error.nativeImgUrl) message.push('请上传320x200图片');
            if (error.native_3ImgUrl) message.push('请上传640x360图片');
            if (error.iconUrl) message.push('请上传LOGO');
            if (message.length) {
                this.$Message.destroy();
                message.forEach((item) => this.$Message.error({ content: item, duration: 2 }));
                return false;
            }
            return true;
        },
        /**
         * @desc 删除info
         */
        deleteInfo(item) {
            if (item == this.currentInfo) this.show.template = false;
            this.$store.commit(
                'infoList',
                this.infoList.filter((info) => info != item)
            );
        },
        /**
         * @desc 从创意库选择创意
         * @param {Array} arr 创意对象
         */
        onLibrarySubmit(arr) {
            this.$store.commit('infoList', [
                ...this.infoList,
                ...arr.map((item) => {
                    if (item.sizeType == 9) item.sizeType = 7;
                    return item;
                }),
            ]);
        },
        /**
         * @desc dataURL转File
         * @param {Dataurl} dataurl base64数据
         * @param {String} filename 文件名
         */
        dataURLtoFile(dataurl, filename) {
            //将base64转换为文件
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
    },
};
</script>
<style lang="scss">
.info {
    .info-title {
        margin-bottom: 0.1rem;
        font-size: 0.16rem;
    }
    .info-list {
        margin: 0.1rem 0;
        padding: 0.2rem;
        border: 1px solid #e0e0e0;
        border-radius: 0.05rem;
        max-height: 50vh;
        overflow: auto;
        .info-group {
            display: flex;
            flex-wrap: wrap;
            position: relative;
            padding-top: 0.3rem;
            margin-bottom: 0.3rem;
            &::before {
                content: attr(data-title);
                font-weight: bold;
                position: absolute;
                top: 0;
                left: 0;
                font-size: 0.16rem;
            }
            .c-info {
                margin-top: 0.1rem;
                margin-right: 0.2rem;
            }
        }
    }
    .template-btn-group {
        border-top: 1px solid #e0e0e0;
        padding-top: 0.2rem;
    }
    .template-box {
        .size-box {
            position: relative;
            display: flex;
            flex-direction: column;
            padding-bottom: 0.2rem;
            &-title {
                padding: 0 0.2rem;
                font-size: 0.16rem;
                margin-bottom: 0.2rem;
            }
            .size-list {
                display: flex;
                cursor: pointer;
                .size-item {
                    flex: 0 0 16.5%;
                    padding: 0 0.08rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    line-height: 1.5;
                    position: relative;
                }
            }
        }
        .text-box {
            position: relative;
            &:not(:nth-child(1)) {
                &::before {
                    content: ' ';
                    border-top: 1px solid #dfe2e5;
                    position: absolute;
                    left: 0.2rem;
                    right: 0.2rem;
                    top: 0;
                }
                padding-top: 0.2rem;
            }
            .text-title {
                display: flex;
                justify-content: space-between;
                padding: 0 0.2rem;
                font-size: 0.16rem;
                margin-bottom: 0.2rem;
            }
        }
        .panel-row {
            margin-bottom: 0.2rem;
            padding: 0 0.2rem;
            .panel-row-label {
                font-size: 0.14rem;
            }
        }
        .native-upload {
            border-top: 1px solid #dfe2e5;
            padding-top: 0.2rem;
            margin-top: 0.2rem;
            margin-bottom: 0;
        }
        .ivu-input {
            height: auto;
        }
        display: flex;
        justify-content: space-between;
        .template {
            width: 6rem;
            border: 1px solid #dfe2e5;
            padding-top: 0.3rem;
            border-radius: 0.05rem;
        }
        .template-group {
            border-top: 1px solid #dfe2e5;
            padding: 0.2rem 0;
            &.space-between {
                display: flex;
                justify-content: space-between;
            }
        }
        .preview {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 4.2rem;
            .preview-nav {
                margin-bottom: 0.1rem;
                .ivu-radio-group-item {
                    // font-size: 0.14rem;
                    padding-left: 0.05rem;
                    padding-right: 0.05rem;
                    line-height: 0.36rem;
                    height: 0.36rem;
                }
            }
            .preview-detail {
                position: relative;
                .preview-tip {
                    text-align: center;
                    padding: 0.1rem 0;
                    font-size: 0.14rem;
                }
                .left,
                .right {
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 0.3rem;
                    width: 0.3rem;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f9f9f9;
                    border-radius: 50%;
                    border: 1px solid #e0e0e0;
                    color: #a0a0a0;
                    font-size: 0.14rem;
                    cursor: pointer;
                }
                .left {
                    left: -0.15rem;
                }
                .right {
                    right: -0.15rem;
                }
            }
        }
    }
    .add-text {
        border-top: 1px solid #dfe2e5;
        padding: 0.2rem 10% 0 10%;
        & > p {
            border-radius: 0.05rem;
            border: 1px dashed #c9c9c9;
            font-size: 0.14rem;
            text-align: center;
            line-height: 0.36rem;
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Creative/Info.vue